(function ($) {
  var $ = jQuery = $;
  
  $(document).ready(function() {  
   
      $(':not(.singleFaq.slide) + .singleFaq.slide, * > .singleFaq.slide:first-of-type').
      each(function() {
        $(this).
        nextUntil(':not(.singleFaq.slide)').
        addBack().
        wrapAll('<div class="qa-wrapper" />');
      }); 
    
    $(".singleFaq.header").click(function(){
      $(this).next().toggle();
      $(this).toggleClass("active");
    });
    
    
    $("#myInput").on("keyup", function() {
      var value = $(this).val().toLowerCase();

      // Always hide q&a sections before filtering
      // This prevents currently opened accordions from showing if
      // they are not matched
      $(".listedFaqs .singleFaq.header")
        .removeClass('active')
        .next('.qa-wrapper')
        .toggle(false);

      $(".listedFaqs .singleFaq.header").each(function() {
        var matched = false;

        // Check heading
        if (matches($(this), value)) {
          matched = true;
        }
        
        // Check items
        $(this).next('.qa-wrapper').find('.cc-accordion-item').each(function () {
          // Match against subheading
          if (matches($('summary', $(this)), value)) {
            matched = true;
          }

          // Match against answer text
          if (matches($('.cc-accordion-item__content', $(this)), value)) {
            matched = true;
          }
        })

        $(this).toggle(matched);
      });
    });    
    
    
  });

  function matches(element, searchText) {
    return element.text().toLowerCase().indexOf(searchText) > -1;
  }

})(theme.jQuery);  
/* Built with Barry v1.0.8 */